import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, Eyebrow } from "../components/Reveal";

const Tile = ({ src, alt, label, className }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <Reveal className={className}>
      <div ref={ref} className="group relative h-full min-h-[360px] overflow-hidden bg-[#18181C]">
        <motion.img style={{ y }} src={src} alt={alt} className="absolute inset-0 h-[116%] w-full -translate-y-[8%] object-cover grayscale transition-[filter] duration-700 group-hover:grayscale-0" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
        <p className="absolute bottom-5 left-5 font-display text-3xl font-black uppercase leading-none md:text-4xl">{label}</p>
      </div>
    </Reveal>
  );
};

export const Lookbook = () => (
  <section id="lookbook" className="border-t border-white/10 bg-[#0d0d0f] px-5 py-24 md:px-12 md:py-36" data-testid="lookbook-section">
    <div className="mx-auto max-w-[1600px]">
      <Reveal className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <Eyebrow>Lookbook · Shot on the street</Eyebrow>
          <h2 className="mt-4 font-display text-6xl font-black uppercase leading-[0.85] tracking-tight md:text-8xl">After<br /><span className="text-outline">Hours</span></h2>
        </div>
        <p className="max-w-sm text-zinc-300">No studios. No retouch. Drop 01 worn where it was made for: stairwells, underpasses, concrete.</p>
      </Reveal>
      <div className="grid grid-cols-1 gap-5 md:grid-cols-12 md:auto-rows-[300px]">
        <Tile className="md:col-span-8 md:row-span-2" src="/img/n4.jpg" alt="Tiger ink back print" label="Tiger Ink / Back Story" />
        <Tile className="md:col-span-4 md:row-span-2" src="/img/n22.png" alt="Madhubani Fish front and back" label="Madhubani Fish" />
        <Reveal className="md:col-span-4">
          <div className="flex h-full min-h-[240px] flex-col justify-between bg-[#00FF66] p-7 text-black">
            <p className="font-mono text-xs font-bold uppercase tracking-widest">Weight check</p>
            <p className="font-display text-8xl font-black leading-none">240<span className="text-3xl"> GSM</span></p>
            <p className="text-sm font-medium">Premium biowash cotton — soft from day one, made to last.</p>
          </div>
        </Reveal>
        <Tile className="md:col-span-4" src="/img/n25.png" alt="Madhubani Peacock back panel" label="Madhubani Peacock" />
        <Reveal className="md:col-span-4">
          <div className="flex h-full min-h-[240px] flex-col justify-between border border-white/15 p-7">
            <p className="font-mono text-xs uppercase tracking-widest text-zinc-400">Spec sheet</p>
            <ul className="space-y-2 font-mono text-sm uppercase">
              <li className="flex justify-between border-b border-white/10 pb-2"><span className="text-zinc-400">Cut</span><span>Drop shoulder</span></li>
              <li className="flex justify-between border-b border-white/10 pb-2"><span className="text-zinc-400">Print</span><span>Screen + AOP</span></li>
              <li className="flex justify-between"><span className="text-zinc-400">Run</span><span className="text-[#00FF66]">Limited</span></li>
            </ul>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
